import React from 'react';
import { Checkbox } from 'antd';

export const handleImpactActualUpdateCheckFilter = (
  impactCurrentFilter,
  attributeFilters,
  setAttributeFilters
) => {
  const options = [
    '<not set>',
    'No actuals (below L3 or cancelled/on hold)',
    'No actuals required or no impacts',
    'Missing actual in last completed month',
    'Missing actual in previous months',
    'Missing actual in last completed and previous completed months',
    'Filled actual (last completed month required only)',
    'Filled actual (previous months required only)',
    'Filled actual (last completed and previous months required)',
  ];
  // Directly set the attributeFilters when the specific filter is active and not already set
  if (
    impactCurrentFilter === 'Actual impact update check (for last completed and previous period)' &&
    !attributeFilters[impactCurrentFilter]
  ) {
    setAttributeFilters(prevFilters => ({
      ...prevFilters,
      [impactCurrentFilter]: options,
    }));
  }

  const handleCheckboxChange = (option) => {
    const isChecked = attributeFilters[impactCurrentFilter]?.includes(option);
    let newFilters;

    if (isChecked) {
      newFilters = {
        ...attributeFilters,
        [impactCurrentFilter]: attributeFilters[impactCurrentFilter].filter(
          (item) => item !== option
        ),
      };
    } else {
      newFilters = {
        ...attributeFilters,
        [impactCurrentFilter]: [...(attributeFilters[impactCurrentFilter] || []), option],
      };
    }

    setAttributeFilters(newFilters);
  };

  const handleSelectAllChange = (e) => {
    setAttributeFilters({
      ...attributeFilters,
      [impactCurrentFilter]: e.target.checked ? options : [],
    });
  };

  const isAllSelected = attributeFilters[impactCurrentFilter]?.length === options.length;
  const isIndeterminate = attributeFilters[impactCurrentFilter]?.length > 0 && !isAllSelected;

  return (
    <div style={{ marginTop: '10px' }}>
      <Checkbox
        indeterminate={isIndeterminate}
        checked={isAllSelected}
        onChange={handleSelectAllChange}
      >
        (Select all)
      </Checkbox>

      {options.map((option) => (
        <div key={option}>
          <Checkbox
            checked={attributeFilters[impactCurrentFilter]?.includes(option)}
            onChange={() => handleCheckboxChange(option)}
          >
            {option}
          </Checkbox>
        </div>
      ))}
    </div>
  );
};